/* eslint-disable @typescript-eslint/no-explicit-any */

import { FormikProvider, useFormik } from 'formik'
import * as yup from 'yup'
import { Container, TextField, Typography } from '@mui/material'
import Dialog from 'components/dialog/dialog'
import type { DetailStateProps, ErrorProps } from 'modules/types'
import type { PartialApproveProps } from 'modules/partial'
import Notification from 'components/notification'
import GLOBAL from 'modules/global'
import { useChangeVinMutation } from 'store/carInformation'
import DialogStyle from './style'

const ChangeVin = ({ open, id, vin, onClose }: DetailStateProps & { id: string; vin: string }) => {
  if (!open) return <></>

  const [changeVin, update] = useChangeVinMutation()

  const scheme = yup.object<PartialApproveProps>({
    Vin: yup.string().required('Vin is required')
  })

  const formik = useFormik<PartialApproveProps>({
    validationSchema: scheme,
    enableReinitialize: true,
    validateOnMount: true,
    initialValues: {
      RegistrationCode: '',
      Vin: vin
    },
    onSubmit: (values: PartialApproveProps) => handleSubmit(values)
  })

  const handleSubmit = (e: PartialApproveProps) => {
    const payload: any = {
      RegistrationCode: id,
      Vin: e.Vin
    }
    changeVin(payload)
  }

  return (
    <>
      <Dialog
        open={open}
        title='Change VIN'
        onCancel={onClose}
        onSubmit={() => formik.handleSubmit()}
        loading={false}
        isDisabled={!formik.isValid}
        submitText='Change'
        cancelText='Cancel'
      >
        <Container {...DialogStyle.Container}>
          {id && (
            <>
              <FormikProvider value={formik}>
                <Typography sx={{ textAlign: 'center' }}>Do you want to Change VIN?</Typography>
                <TextField
                  id='Vin'
                  value={formik.values.Vin}
                  multiline
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched && formik.touched.Vin && Boolean(formik.errors.Vin)}
                  helperText={
                    formik.touched && formik.touched.Vin && formik.errors && formik.errors.Vin
                  }
                />
              </FormikProvider>
            </>
          )}
        </Container>
      </Dialog>

      <Notification
        open={!update.isLoading && !update.isUninitialized}
        onClose={() => (update.isError ? update.reset() : location.reload())}
        isError={update.isError}
        message={GLOBAL.returnExceptionMessage(update.isError, update.error as ErrorProps)}
      />
    </>
  )
}

export default ChangeVin
